import React from 'react'

type Props = {
    className?: string
}

export const SunMoonIcon = (props: Props) => {
    const { className = "w-5 h-5" } = props
    return (
        <svg fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" className={className}>
            <path d="M12 2v2"/>
            <path d="M14.837 16.385a6 6 0 1 1-7.223-7.222c.624-.147.97.66.715 1.248a4 4 0 0 0 5.26 5.259c.589-.255 1.396.09 1.248.715"/>
            <path d="M16 12a4 4 0 0 0-4-4"/>
            <path d="m19 5-1.256 1.256"/>
            <path d="M20 12h2"/>
        </svg>
    )
}
